module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "color": "primary darken-2",
      "dark": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "height": "400px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('h2', {
    staticClass: "display-1"
  }, [_vm._v("Система \"АТЛАНТ-СМАРТ\"")]), _vm._v(" "), _c('h3', [_vm._v("удобная и быстрая система проверки контрагентов и партнеров.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "to": "/clients"
    }
  }, [_vm._v("Поиск контрагентов")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Критерии поиска")]), _vm._v(" "), _c('div', [_vm._v("\n        Система позволяет осуществлять поиск Юридических Лиц на основе текущих и исторических данных о названиях, адресах, руководителях, участниках и уставном капитале компаний. \n      ")])])], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Аспекты проверки и источники данных")]), _vm._v(" "), _c('div', [_vm._v("\n        Система позволяет проверять контрагентов на основе данных, полученных из официальных источников.\n      ")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.aspects), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "100%"
      }
    }, [_c('v-card-title', [_c('v-container', {
      attrs: {
        "fluid": "",
        "grid-list-lg": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-img', {
      attrs: {
        "src": item.img,
        "height": "64px",
        "contain": ""
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('div', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.nameShort))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', _vm._l((item.items), function(item) {
      return _c('div', [_vm._v(_vm._s(item.name))])
    }), 0)], 1)], 1)]
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', [_c('div', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Регистрация в системе")]), _vm._v("\n      Дополнительные сервисы для зарегистрированных пользователей\n      ")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.features), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "100%"
      }
    }, [_c('v-container', {
      attrs: {
        "fluid": "",
        "grid-list-lg": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_c('v-card-title', [_c('div', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.nameShort))])])]), _vm._v(" "), _c('v-card-text', [_c('span', [_vm._v(_vm._s(item.name))])])], 1)], 1)], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d10aefd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePanel.vue
// module id = 1141
// module chunks = 1